import { LegacyStreetAddressStorageManager } from "./LegacyStreetAddressStorageManager";
export const STREET_ADDRESS_KEY = "client_street_address";
export class StreetAddressStorageManager {
    store(streetAddress) {
        const streetAddressDataString = JSON.stringify(streetAddress);
        localStorage.setItem(STREET_ADDRESS_KEY, streetAddressDataString);
    }
    restore() {
        const streetAddressDataString = localStorage.getItem(STREET_ADDRESS_KEY);
        if (streetAddressDataString === null) {
            return new LegacyStreetAddressStorageManager().restore();
        }
        return JSON.parse(streetAddressDataString);
    }
    erase() {
        localStorage.removeItem(STREET_ADDRESS_KEY);
    }
}
